import loader from '../modules/loader';
import { xhrLoad } from '../functions/xhrLoad';
import { querySelector, querySelectorAll } from '../functions/querySelectors';
import moving from '../modules/moving';
import { setListenersFromSelector } from '../functions/listeners';
import { DEFAULT_TRANSITION_TIME } from '../config/main';
import afterUpdate from '../modules/afterUpdate';

const GLOBAL_LISTENER_INIT_CLASS = 'ai-init';
const WRAP_CLASS = 'l-alert';
const ITEM_CLASS = 'l-alert__item';
const CLOSE_JS_CLASS = 'js-alert-close';
const CLOSE_JS_INIT_CLASS = 'jac-init';
const CNT_CLASS = 'l-alert__cnt';
const SHOW_CLASS = `${ITEM_CLASS}--show`;
const HIDING_CLASS = `${ITEM_CLASS}--hiding`;
const LAYOUT = `<div class="l-alert__bg ${CLOSE_JS_CLASS}"></div><div class="${CNT_CLASS}"></div>`;
const BODY_CLASS = 'alert-open';

let getAlertWrap = function() {
  let wrap = querySelector(`.${WRAP_CLASS}`);

  if (!wrap) {
    wrap = document.createElement('div');
    wrap.classList.add(WRAP_CLASS);
    document.body.appendChild(wrap);
  }

  return wrap;
};

let setListeners = function(alert, _options) {
  setListenersFromSelector(
    `.${CLOSE_JS_CLASS}`,
    CLOSE_JS_INIT_CLASS,
    closeClick,
    true,
    'click',
    alert
  );

  if (typeof _options.closeCb === 'function') {
    alert.addEventListener('closeAlert', _options.closeCb);
  }
};

let setGlobalListener = function() {
  if (!document.body.classList.contains(GLOBAL_LISTENER_INIT_CLASS)) {
    document.body.addEventListener('keydown', bodyKeydown);
    document.body.classList.add(GLOBAL_LISTENER_INIT_CLASS);
  }
};

let destroyGlobalListener = function() {
  if (document.body.classList.contains(GLOBAL_LISTENER_INIT_CLASS)) {
    document.body.removeEventListener('keydown', bodyKeydown);
    document.body.classList.remove(GLOBAL_LISTENER_INIT_CLASS);
  }
};

let createAlert = function(modifs = []) {
  let alert = document.createElement('div');
  alert.classList.add(ITEM_CLASS);
  alert.innerHTML = LAYOUT;

  for (let i in modifs) {
    alert.classList.add(`${ITEM_CLASS}--${modifs[i]}`);
  }

  return alert;
};

let fill = function(_options) {
  let wrap = getAlertWrap();
  let alert = createAlert(_options.modifs);
  let alertCnt = querySelector(`.${CNT_CLASS}`, alert);

  if (_options.nodeElement) {
    alertCnt.appendChild(_options.nodeElement);
  }
  else {
    alertCnt.innerHTML = _options.html;
  }

  wrap.appendChild(alert);
  moving.disable();
  document.body.classList.add(BODY_CLASS);
  afterUpdate.update();

  setTimeout(function() {
    alert.classList.add(SHOW_CLASS);

    if (typeof _options.openCb === 'function') {
      _options.openCb();
    }
  }, 100);

  setGlobalListener();
  setListeners(alert, _options);
};

let open = function(options) {
  let _options = {
    html: null,
    url: null,
    urlMethod: 'get',
    urlParams: {},
    nodeElement: null,
    closeCb: null,
    modifs: null,
    openCb: null
  };

  Object.assign(_options, options);

  if (_options.url) {
    loader.show();

    xhrLoad(_options.url, function(response) {
      _options.html = response;
      fill(_options);
      loader.hide();
    }, function() {
      loader.hide();
    }, _options.urlMethod, _options.urlParams);
  }
  else {
    fill(_options);
  }
};

let closeClick = function(event) {
  event.preventDefault();

  close(this.closest(`.${ITEM_CLASS}`));
};

let bodyKeydown = function(event) {
  if (event.keyCode === 27) { // esc
    close();
  }
};

let close = function(alert = null) {
  let alerts = querySelectorAll(`.${ITEM_CLASS}:not(.${HIDING_CLASS})`);

  if (!alert) {
    alert = alerts[alerts.length - 1];

    if (!alert) {
      return;
    }
  }

  alert.classList.remove(SHOW_CLASS);
  alert.classList.add(HIDING_CLASS);

  if (alerts.length <= 1) {
    document.body.classList.remove(BODY_CLASS);
  }

  setTimeout(function() {
    // eslint-disable-next-line no-undef
    let event = new CustomEvent('closeAlert');
    alert.dispatchEvent(event);

    alert.parentNode.removeChild(alert);

    if (alerts.length <= 1) {
      moving.enable();
      destroyGlobalListener();
    }
  }, DEFAULT_TRANSITION_TIME);
};

export default {
  open: open,
  close: close
};
